import { render, staticRenderFns } from "./EditCollection.vue?vue&type=template&id=09e7ebbf&scoped=true&"
import script from "./EditCollection.vue?vue&type=script&lang=js&"
export * from "./EditCollection.vue?vue&type=script&lang=js&"
import style0 from "./EditCollection.vue?vue&type=style&index=0&id=09e7ebbf&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09e7ebbf",
  null
  
)

export default component.exports